'use client'

import {FormTestingStore} from '../store'
import {observer, useLocalObservable} from 'mobx-react'
import React from 'react'

const FormTestingContext = React.createContext<Nullable<FormTestingStore>>(null)

export const FormTestingProvider = observer(({children}: React.PropsWithChildren) => {
  const store = useLocalObservable(() => new FormTestingStore())

  return <FormTestingContext.Provider value={store}>{children}</FormTestingContext.Provider>
})

export const useFormTesting = () => {
  const store = React.useContext(FormTestingContext)

  if (!store) throw Error('useFormTesting must be wrappe in FormTestingProvider')

  return store
}
